var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ripple-container lightBg",class:{ lightBg: _vm.isLight },style:(_vm.style)},[_c('div',{staticClass:"ripple"}),_c('div',{staticClass:"ripple"}),_c('div',{staticClass:"ripple"}),_c('div',{staticClass:"ripple"})])
}
var staticRenderFns = []

export { render, staticRenderFns }